"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_trackisafe__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b4ae724d-d4d2-443a-add4-6a45e5596c5c",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 191.5"
  }, props), /*#__PURE__*/React.createElement("title", null, "trackisafe-hi"), /*#__PURE__*/React.createElement("g", {
    id: "6fadda62-b815-4453-9696-6713565b8616",
    "data-name": "373c953c-d621-43bf-a15d-17d71a35b79d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cb87331c-9e5e-4f27-b81b-53371fc55958",
    "data-name": "102ab36b-e6fc-4144-8c40-b83f145a422f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ba312d43-2cef-4605-ac6b-9603663549d3",
    "data-name": "3f3f9848-954b-4c80-9316-6edde97917df"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9258b511-97c9-47a0-9816-4ffd5a91fb4d",
    "data-name": "67b4b6fe-d328-401f-947c-99e99183cd76"
  }, /*#__PURE__*/React.createElement("g", {
    id: "596ed5f3-339d-4ce3-af77-a6a66a65a5c0",
    "data-name": "aa56db2f-935f-4889-ad6e-0c0e60ed9537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "97fca4ee-a6ad-474b-9954-8f1f6831d1fa",
    "data-name": "35f3bfa9-f785-4a4b-83ec-8a538895cd51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "82fea218-ff6b-4d10-85bc-1a0eca1a089b",
    "data-name": "12d631b1-9cfd-4c96-9b67-bdf1331d97f1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4685d897-8357-4853-8f81-6f07afa69095",
    "data-name": "f1c18c67-cc58-42e8-bbe0-b1cbcd947c05"
  }, /*#__PURE__*/React.createElement("g", {
    id: "74aee1fa-216b-4f76-9bad-bcb78136080e",
    "data-name": "7e703ead-252c-40dc-82cc-a9f07a644490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "68d730b7-2546-4fd4-8374-c3baf5fcc0b7",
    "data-name": "7816ff7f-7ea1-4ba5-8972-83eb3ae23862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3211b9e7-84f4-4c75-a097-b20d506de40d",
    "data-name": "c1f1787b-5547-47fc-b3f7-ea924824ef27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "765078f9-e9bf-449d-a4e6-d89acd13f7e5",
    "data-name": "140b9713-f06c-47da-bce6-365502d067fb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22b074f8-91c8-42fd-89a8-a2a85d10abad",
    "data-name": "a813ed91-5d9f-4da8-bc3e-ab3f02093cde"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9baf0a9e-6eb7-45b0-b31e-bd88b2710335",
    "data-name": "30e2e413-1c1f-40b7-aefa-fee526f67a0d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4c6e2343-11e0-486e-8f36-56f3678711b9",
    "data-name": "ecab46a3-a2f7-4687-8edf-8b7bb5f8be48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "66681664-4357-4d3e-a02f-3c01de832a60",
    "data-name": "253b7143-7844-4f4d-a6bd-8f099cf90392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "105b00ca-6984-4c3a-93e5-d80e1b660ef0",
    "data-name": "ed11cbf7-f6b8-49f5-b8b9-0ac7409ccf2a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3ed777b3-511e-4e7c-8b42-e72cfb047d58",
    "data-name": "81894a57-c1d0-4f98-bb88-c20e77d668d8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a7c2d488-061f-4336-be53-c358e2bc97a6",
    "data-name": "0dbe78db-5dca-46c0-8524-7f14dc340d14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4f25897e-f2c5-49ac-8a51-4469433b0326",
    "data-name": "709aca1e-8fe8-49b1-b312-066c5eb77d0a"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8bba75b1-d5d4-4d99-ba42-6ecea2895beb",
    "data-name": "f35df3da-db01-4e0b-b344-d53ad6631218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3566f19a-adfc-46dd-bbb2-e4d31e1d4168",
    "data-name": "17ba56bd-a6d4-44ef-96be-408aec84e8e6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 191.5,
    fill: "none"
  }))))))))))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "M159.12,79.29c0,42-62.88,96.54-62.88,96.54S33.36,121.26,33.36,79.29a62.88,62.88,0,1,1,125.76,0Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,173.83S34.4,120.16,33.38,78.34c0,.32,0,.63,0,1,0,42,62.88,96.54,62.88,96.54s62.88-54.57,62.88-96.54c0-.32,0-.63,0-1C158.07,120.16,96.24,173.83,96.24,173.83Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.86,
    cy: 116.69,
    r: 5.72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.28,
    cy: 116.69,
    r: 5.72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.46,
    cy: 116.69,
    r: 5.72,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.43,120.28a5.73,5.73,0,0,1-5.62-4.66,6.26,6.26,0,0,0-.1,1.07,5.73,5.73,0,0,0,11.45,0,6.26,6.26,0,0,0-.1-1.07A5.73,5.73,0,0,1,71.43,120.28Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.86,120.28a5.73,5.73,0,0,1-5.63-4.66,6.26,6.26,0,0,0-.1,1.07,5.73,5.73,0,0,0,11.45,0,6.26,6.26,0,0,0-.1-1.07A5.73,5.73,0,0,1,95.86,120.28Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.28,120.28a5.72,5.72,0,0,1-5.62-4.66,5.39,5.39,0,0,0-.11,1.07,5.73,5.73,0,0,0,11.45,0,6.26,6.26,0,0,0-.1-1.07A5.73,5.73,0,0,1,120.28,120.28Z",
    opacity: 0.06
  }));
}

var _default = ic_trackisafe__dark;
exports.default = _default;